import { Carousel } from './components/Carousel/index'
export const Slider = Carousel
export { StyledCarousel, StyledSlider, StyledUl } from './components/Carousel/Carousel.styled'
export { StyledSlide } from './components/Slide/Slide.styled'
export { StyledNavWrapper, StyledArrow } from './components/NavArrow/NavArrow.styled'
